import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../lib/api';

export function Login({
  onAuth,
}: {
  onAuth: (user: { id: string; email: string; role: string; shop_id: string | null }) => void;
}) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await authApi.login(email, password);
      if (res.user.role !== 'merchant' && res.user.role !== 'admin') {
        setError('Ce compte n’est pas un compte commerçant.');
        return;
      }
      onAuth(res.user);
      navigate('/');
    } catch (err) {
      const code = (err as Error).message;
      setError(
        code === 'invalid_credentials'
          ? 'Email ou mot de passe invalide.'
          : code === 'rate_limited'
            ? 'Trop de tentatives. Réessayez dans 1 minute.'
            : 'Connexion impossible. Réessayez.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="card login-card" onSubmit={submit}>
        <h2 style={{ marginTop: 0, color: 'var(--primary)' }}>Reims Local</h2>
        <p className="muted" style={{ marginTop: -12 }}>Espace commerçant</p>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="form-row">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="form-row">
          <label htmlFor="password">Mot de passe</label>
          <input id="password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button className="primary" type="submit" style={{ width: '100%' }} disabled={loading}>
          {loading ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>
    </div>
  );
}
